import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../../../assets/css/customer/services/ServicesHero.css';

const ServicesHero = () => {
  return (
     <section className="contact-hero-section">
         <Container>
           <div className="contact-hero-content">
             {/* Main Heading */}
             <h1 className="contact-hero-heading">Blogs</h1>
   
             {/* Description */}
             <p className="contact-hero-description">
               Browse our blogs for expert advice, planning tips, and creative ideas to help you design and manage your dream wedding effortlessly.
             </p>
           </div>
         </Container>
       </section>
  );
};

export default ServicesHero;